// Shared CRM button style tokens.
// Mirrors the Finish / Cancel buttons in AttendedAppointment.jsx (lines 602–642).
// Import in any component that needs to match the standard CRM button look.

export const CRM_PRIMARY_BUTTON_SX = {
    bgcolor: '#00AB55',
    color: '#ffffff',
    fontSize: '13px',
    fontWeight: 600,
    letterSpacing: '-0.01em',
    textTransform: 'none',
    borderRadius: '6px',
    boxShadow: 'none',
    px: 2.25,
    py: 0.75,
    minWidth: '88px',
    '&:hover': { bgcolor: '#02934A', boxShadow: 'none' },
    '&:active': { bgcolor: '#017A3D' },
    '&.Mui-disabled': { bgcolor: 'rgba(0, 171, 85, 0.35)', color: '#ffffff' },
    '&.MuiLoadingButton-loading': { bgcolor: 'rgba(0, 171, 85, 0.35)' },
};

export const CRM_SECONDARY_BUTTON_SX = {
    color: '#1d1d1f',
    fontSize: '13px',
    fontWeight: 500,
    letterSpacing: '-0.01em',
    textTransform: 'none',
    px: 2,
    py: 0.75,
    borderRadius: '6px',
    '&:hover': { bgcolor: 'rgba(0,0,0,0.04)' },
};
